<template>
    <div id="app" :class="[
        `${$route.name}`,minwidth
    ]">
        <router-view />
        <!-- 异步组件，比如弹窗 -->
        <div>
            <component
                v-for="(item, index) in coms"
                :key="index"
                :is="item"
                v-on="item.listeners"
                v-bind="item.attrs"
            >
                <component
                    v-for="(ite, inde) in item.slots"
                    :is="ite"
                    :key="`${index}_${inde}`"
                    v-on="ite.listeners"
                    v-bind="ite.attrs"
                ></component>
            </component>
        </div>
        <!-- 临时 div，用于生成并获取 class，应用到 body 上 -->
        <div id="ksh34m2s" :class="bodyClass" style="display: none;"></div>
    </div>
</template>

<script>
import Vue from "vue";
import TopNav from "@/components/TopNav.vue";
import i18n from './lang'


Vue.component("TopNav", TopNav);

export default {
    name: "App",
    data(){
        return {
            i18n: i18n,
            minwidth: 'minwidth-zh-cn',
        }
    },
    watch: {
        // 绑定 bodyClass 到 body 上
        bodyClass() {
            this.$nextTick(() => {
                document.body.classList =
                    document.querySelector("#ksh34m2s").classList;
            });
        },
        // 根据语言 切换导航长度
        "i18n.locale"(val){
            this.$nextTick(() => {
                this.minwidth = 'minwidth-'+val;
            });
        }
    },
};
</script>

<style lang="less">
#app{
    font-family: Microsoft Yahei,PingFang SC,Verdana,Helvetica Neue,Hiragino Sans GB,"Microsoft Sans Serif",WenQuanYi Micro Hei,"sans-serif";
}
.minwidth-zh-cn{
    min-width: 1366px;
}
.minwidth-en-us{
    min-width: 1550px;
}
</style>
